/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/ReplaceSymbols.ts
 * @create:      2025-07-01 18:02:15.092
 * @modify:      2025-07-11 21:19:12.948
 * @version:     6.0.0
 * @times:       5
 * @lines:       80
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { ArrayFindDuplicates } from "../array/ArrayFindDuplicates";
import { ReplaceAll } from "../string/ReplaceAll";
import { GetChineseEnglishSymbolMappings } from "../data/GetChineseEnglishSymbolMappings";

/**
 * Replaces Chinese symbols with English symbols or vice versa in the input string.
 * 
 * @param input - The input string in which symbols will be replaced.
 * @param to - The target language for symbol replacement, either "en" for English or "zh" for Chinese.
 * @returns The input string with symbols replaced according to the target language.
 * 
 * @since 4.5.1
 * @version 2025-06-12
 */
export function ReplaceSymbols(input: string, to: "en" | "zh") {
    if (to === "en") {
        const mappings = GetChineseEnglishSymbolMappings().sort((a, b) => b.zh.length - a.zh.length);;
        const duplicates = ArrayFindDuplicates(mappings.map(p => p.zh));

        for (const mapping of mappings) {
            if (duplicates.includes(mapping.zh)) {
                continue;
            }

            input = ReplaceAll(input, mapping.zh, mapping.en);
        }

        return input;
    }

    if (to === "zh") {
        const mappings = GetChineseEnglishSymbolMappings().sort((a, b) => b.en.length - a.en.length);;
        const duplicates = ArrayFindDuplicates(mappings.map(p => p.en));

        for (const mapping of mappings) {
            if (duplicates.includes(mapping.en)) {
                continue;
            }

            input = ReplaceAll(input, mapping.en, mapping.zh);
        }

        return input;
    }

    return input;
}
